module.exports = __webpack_public_path__ + "img/41-image-2@2x.9abea79b.png";